import React, { FC, ReactNode, useEffect, useState } from 'react'

import { RequiredFieldsCardItem } from '../RequiredFieldsCardItem/RequiredFieldsCardItem'
import { CardEmpty } from '../../empty/CardEmpty/CardEmpty'

import { getUserRequiredFields } from '../../../../../../helpers/requiredFields'
import { useProfile } from '../../../../../../hooks/useProfile'

import { IUserInterface } from '../../../../../../models/users/user.interface'
import { IProfileReqField } from '../../../../../../pages/competitor/clinicAndOther/Tabs/components/ProfileFields'

interface RequiredFieldsCardProps {
  activeTab?: 'overview'
  user: IUserInterface | null
  setUser?: (state: IUserInterface) => void
  className?: string
  isCollapsible?: boolean
  onActionClick?: () => void
  actionIcon?: ReactNode
  eventRequiredUserFields?: string[]
  isEditable?: boolean
}

export const UserRequiredFieldsCard: FC<RequiredFieldsCardProps> = ({
  activeTab,
  user,
  setUser,
  className,
  isCollapsible,
  onActionClick,
  actionIcon,
  eventRequiredUserFields,
  isEditable,
}) => {
  const { onSaveEditUser, onCancelEditUser, onChangeUserInput } = useProfile()

  const [requiredFields, setRequiredFields] = useState<IProfileReqField[]>([])
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    if (user) {
      const fields = getUserRequiredFields({ user, eventRequiredUserFields })
      setRequiredFields(fields)
    }
  }, [eventRequiredUserFields, user])

  if (!user) return <CardEmpty />

  return (
    <RequiredFieldsCardItem
      activeTab={activeTab}
      isCollapsible={isCollapsible}
      actionIcon={actionIcon}
      onActionClick={onActionClick}
      className={className}
      requiredFields={requiredFields}
      onCancelEdit={() => onCancelEditUser({ user, setUser, setIsEdit })}
      onSaveEdit={() => onSaveEditUser({ user, setIsEdit })}
      onChange={({ fieldName, fieldType, fieldKey, option }) =>
        onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
      }
      isEditable={isEditable}
      setIsEdit={setIsEdit}
      isEdit={isEdit}
    />
  )
}
